import React from "react";
import { useOverlayContext } from "../OverlayContext";

/**
 * Проверяет, открыт ли хотя бы один overlay из заданного набора `key`.
 *
 * @param keys стабильные ключи из `defineMobileWindow` / `defineMobileFormWindow`
 * @returns `true`, если в overlay-стеке есть window или dialog с одним из ключей
 */
export function useIsOverlayOpenByKeys(keys: readonly string[]): boolean {
    const { entries } = useOverlayContext();
    const keysSignature = keys.join("\0");

    return React.useMemo(() => {
        if (keys.length === 0) {
            return false;
        }

        const keysSet = new Set(keys);
        return entries.some((entry) => entry.key != null && keysSet.has(entry.key));
    }, [entries, keys, keysSignature]);
}
